var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sui-form',{on:{"submit":function($event){$event.preventDefault();}}},[_c('h3',[_vm._v("Route")]),_c('sui-form-field',[_c('label',[_vm._v("File (in .gpx format)")]),_c('input',{attrs:{"type":"file"},on:{"change":_vm.updateRoute}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }